/** `localStorage` key when the Mis Lotes guided tour finished or was dismissed. */
export const MY_FIELDS_TOUR_STORAGE_KEY = 'consultant-fields-lots-tour-completed';

/** DOM anchors for the Mis Lotes tour (`driver.js`). Applied only when `lotsTourAnchors` is enabled on this route. */
export const MY_FIELDS_TOUR_IDS = {
    INTRO: 'lotes-intro',
    WIDGETS: 'widgets-l',
    ASSIGN_BTN: 'btn-asignar-productor',
    TABS: 'tabs-bar-l',
} as const;
